import { render, staticRenderFns } from "./AuditsTable.vue?vue&type=template&id=6e8b19de&scoped=true&"
import script from "./AuditsTable.vue?vue&type=script&lang=js&"
export * from "./AuditsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditsTable.vue?vue&type=style&index=0&id=6e8b19de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b19de",
  null
  
)

export default component.exports